module.exports = __webpack_public_path__ + "images/mobile-background.png?v=63ac3bf00f3b984297bc39721b0f7d24";